import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";

/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var contentTags = makeEntityScaffold('SAGA.API.GET_CONTENT_TAGS', function (client, type, ids) {
  return client.tags.contentTags({
    content_type: type,
    content_ids: ids
  }).then(function (data) {
    return data.content;
  });
}, {
  defaultKey: function defaultKey(client, type, ids) {
    return "".concat(type, "_").concat(ids.join('_'));
  }
});
export var contentTagsV2 = makeEntityScaffold('SAGA.API.GET_CONTENT_TAGS_V2', function (client, type, ids) {
  return client.tags.contentTagsV2({
    content_type: type,
    content_ids: ids
  }).then(function (data) {
    return data.content;
  });
}, {
  defaultKey: function defaultKey(client, type, ids) {
    return "".concat(type, "_").concat(ids.join('_'));
  }
});
export var taggedContent = makeEntityScaffold('SAGA.API.GET_TAGGED_CONTENT', function (client, type, tags) {
  return client.tags.taggedContent({
    content_type: type,
    tags: tags
  }).then(function (data) {
    return data.content_ids;
  });
}, {
  defaultKey: function defaultKey(client, type, tags) {
    return "".concat(type, "_").concat(tags.join('_'));
  }
});
export var tagList = makeEntityScaffold('SAGA.API.GET_TAGS', function (client, options) {
  return client.tags.getV3(options).then(function (data) {
    return data.tags;
  });
}, {
  defaultKey: 1
});